import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"

import {
  getCarCareServices,
  getCarCareService,
  createCarCareService,
  updateCarCareService,
  deleteCarCareService,
} from "api/carCareServiceApi"

export const CAR_CARE_SERVICE_QUERY_KEY = "car-care-services"

// -------------------- FETCH PAGINATED --------------------
export const useCarCareServices = (params = {}, enabled = true) => {
  return usePaginatedResource(
    CAR_CARE_SERVICE_QUERY_KEY,
    getCarCareServices,
    params,
    enabled
  )
}

// -------------------- FETCH SINGLE ITEM --------------------
export const useCarCareService = (id, enabled = true) => {
  return useResourceItem(
    CAR_CARE_SERVICE_QUERY_KEY,
    getCarCareService,
    id,
    enabled
  )
}

// -------------------- CREATE --------------------
export const useCreateCarCareService = () => {
  return useCreateResource(createCarCareService, CAR_CARE_SERVICE_QUERY_KEY)
}

// -------------------- EDIT --------------------
export const useEditCarCareService = () => {
  return useEditResource(updateCarCareService, CAR_CARE_SERVICE_QUERY_KEY)
}

// -------------------- DELETE (Soft Delete) --------------------
export const useDeleteCarCareService = () => {
  return useDeleteResource(deleteCarCareService, CAR_CARE_SERVICE_QUERY_KEY)
}
